import { IsoDate } from '../utils/iso-date';

/** Primeiro dia com Desafio Diário disponível — data mínima selecionável. */
export const DAILY_CHALLENGE_START_DATE: IsoDate = '2026-10-01';
